import {isEmpty, isEqual} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import {Form} from 'react-bootstrap';

import styles from './FilterNodeTypeFulltext.less';
import {FilterNodeTypeWrapper} from './FilterNodeTypeWrapper';
import {FilterSubmitButton} from './FilterSubmitButton';
import {DynamicFilter, Filter, FILTER_TYPE_TEXT} from 'src/js/lib/filtering';
import {FilterNode as FilterNodeModel} from 'src/js/model/filters_config';

class FilterNodeTypeFulltext extends React.PureComponent {
  constructor(props) {
    super(props);
    this.changeOrRemoveFilter = this.changeOrRemoveFilter.bind(this);
    this.getFilter = this.getFilter.bind(this);
    this.getValue = this.getValue.bind(this);
    this.handleChangeText = this.handleChangeText.bind(this);
    this.handleButtonSubmit = this.handleButtonSubmit.bind(this);

    this.state = {
      text: '',
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (
      props.selectedFilter &&
      !isEqual(props.selectedFilter, state.prevSelectedFilter)
    ) {
      return {
        text: props.selectedFilter ? props.selectedFilter.getValue() : '',
        prevSelectedFilter: props.selectedFilter,
      };
    }

    // Return null to indicate no change to state.
    return null;
  }

  handleChangeText(event) {
    if (event) {
      event.stopPropagation();
    }
    this.setState({text: event.target.value});
  }

  handleButtonSubmit() {
    const {text} = this.state;
    this.changeOrRemoveFilter(text);
  }

  getFilter(value) {
    const {node} = this.props;
    const TextFilter = DynamicFilter.getFilterClass(FILTER_TYPE_TEXT);
    return new TextFilter({
      node,
      type: FILTER_TYPE_TEXT,
      property: node.getName(),
      value,
    });
  }

  getValue() {
    const {text} = this.state;
    return text;
  }

  isDisabled() {
    const {selectedFilter} = this.props;
    const {text} = this.state;
    return text === (selectedFilter ? selectedFilter.getValue() : '');
  }

  changeOrRemoveFilter(value) {
    const {changeFilter, removeFilter} = this.props;
    const filter = this.getFilter(value);
    if (isEmpty(value)) {
      removeFilter(filter);
    } else {
      changeFilter(filter);
    }
  }

  render() {
    const {
      inputRef,
      isOpened,
      node,
      toggleOpened,
      removeFilter,
      selectedFilter,
      setFocus,
    } = this.props;
    const filter = this.getFilter();

    return (
      <FilterNodeTypeWrapper
        filter={filter}
        isOpened={isOpened}
        node={node}
        removeFilter={removeFilter}
        setFocus={setFocus}
        selectedFilter={selectedFilter}
        toggleOpened={toggleOpened}
      >
        <Form.Control
          as='textarea'
          size='sm'
          className={styles.dlFilterNodeTypeFulltextInput}
          tabIndex={isOpened ? 0 : -1}
          ref={inputRef}
          rows={3}
          spellCheck={'false'}
          value={this.getValue(filter)}
          onChange={this.handleChangeText}
        />
        <FilterSubmitButton
          onClick={this.handleButtonSubmit}
          isDisabled={this.isDisabled()}
          tabIndex={isOpened ? 0 : -1}
        />
      </FilterNodeTypeWrapper>
    );
  }
}

FilterNodeTypeFulltext.displayName = 'FilterNodeTypeFulltext';

FilterNodeTypeFulltext.propTypes = {
  inputRef: PropTypes.func.isRequired,
  isOpened: PropTypes.bool,
  node: PropTypes.instanceOf(FilterNodeModel).isRequired,
  changeFilter: PropTypes.func.isRequired,
  removeFilter: PropTypes.func.isRequired,
  selectedFilter: PropTypes.instanceOf(Filter),
  setFocus: PropTypes.func.isRequired,
  toggleOpened: PropTypes.func.isRequired,
};

FilterNodeTypeFulltext.defaultProps = {
  isOpened: false,
  selectedFilter: undefined,
};

export default FilterNodeTypeFulltext;
